/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseRejectionReason,
    ResponseRejectionReasonFromJSON,
    ResponseRejectionReasonFromJSONTyped,
    ResponseRejectionReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface ResponseInfo
 */
export interface ResponseInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseInfo
     */
    associatedObjectIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseInfo
     */
    attachmentIds?: Array<string> | null;
    /**
     * 
     * @type {ResponseRejectionReason}
     * @memberof ResponseInfo
     */
    responseRejectionReason?: ResponseRejectionReason;
}

export function ResponseInfoFromJSON(json: any): ResponseInfo {
    return ResponseInfoFromJSONTyped(json, false);
}

export function ResponseInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'associatedObjectIds': !exists(json, 'associatedObjectIds') ? undefined : json['associatedObjectIds'],
        'attachmentIds': !exists(json, 'attachmentIds') ? undefined : json['attachmentIds'],
        'responseRejectionReason': !exists(json, 'responseRejectionReason') ? undefined : ResponseRejectionReasonFromJSON(json['responseRejectionReason']),
    };
}

export function ResponseInfoToJSON(value?: ResponseInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'associatedObjectIds': value.associatedObjectIds,
        'attachmentIds': value.attachmentIds,
        'responseRejectionReason': ResponseRejectionReasonToJSON(value.responseRejectionReason),
    };
}


